import { gql } from "apollo-boost"

export const updateContracts = gql`
 mutation updateContracts($id: ID!, $data: CreateContractsInput!) {
  UpdateContracts(id: $id, data: $data)
  }
`